import type { IconProps } from './types';

function ImageAnalysisIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M17.5 1H23V6.5M6.5 1H1V6.5M17.5 23H23V17.5M6.5 23H1V17.5M5 19H19V17.6248L14.8 13.5L12.7 15.5625L8.5 11.4375L5 14.875V19ZM14.8 8C15.5732 8 16.2 8.61561 16.2 9.375C16.2 10.1344 15.5732 10.75 14.8 10.75C14.0268 10.75 13.4 10.1344 13.4 9.375C13.4 8.61561 14.0268 8 14.8 8Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { ImageAnalysisIcon };
